<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "UserMappingGTIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
